var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H64C68.4183 0 72 3.58172 72 8V44C72 48.4183 68.4183 52 64 52H8C3.58172 52 0 48.4183 0 44V8Z",
    fill: "#FFE1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9414 34V29.828H9.44944L9.11344 27.112L18.2414 14.764H22.4134V26.832H25.0734V29.828H22.4134V34H18.9414ZM12.8374 26.832H18.9414V18.572L12.8374 26.832ZM36.0116 34.336C31.0556 34.336 27.5556 30.22 27.5556 24.368C27.5556 18.544 31.0556 14.428 36.0116 14.428C40.9396 14.428 44.4116 18.544 44.4116 24.368C44.4116 30.22 40.9396 34.336 36.0116 34.336ZM36.0116 31.144C38.8396 31.144 40.8556 28.344 40.8556 24.368C40.8556 20.392 38.8396 17.62 36.0116 17.62C33.1556 17.62 31.1396 20.392 31.1396 24.368C31.1396 28.344 33.1556 31.144 36.0116 31.144ZM56.4844 34V29.828H46.9924L46.6564 27.112L55.7844 14.764H59.9564V26.832H62.6164V29.828H59.9564V34H56.4844ZM50.3804 26.832H56.4844V18.572L50.3804 26.832Z",
    fill: "#9E1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.99175bb182b7e73e7bd10a52f5eac919.svg";
export { ForwardRef as ReactComponent };